import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import { IconButton, ICON_TYPES } from '@st-operations/uikit/src/v2/index.js'

import './styles.scss'

export const useCollapsible = ({ initialOpen = true } = {}) => {
  const [open, setOpen] = useState(initialOpen)
  const [contentContainer, setContentContainer] = useState()
  const [collapsibleHeight, setCollapsibleHeight] = useState()

  useEffect(() => {
    if (!contentContainer) {
      return
    }
    const resizeObserver = new ResizeObserver((entries) => {
      const height = entries[0].contentRect
      setCollapsibleHeight(height)
    })

    resizeObserver.observe(contentContainer)

    return () => {
      resizeObserver.unobserve(contentContainer)
    }
  }, [contentContainer])

  return {
    open,
    setOpen,
    getCollapsibleRef: (ref) => setContentContainer(ref),
    collapsibleHeight,
  }
}

const CollapsibleSection = ({ title, description, children, initialOpen = true }) => {
  const { open, setOpen, getCollapsibleRef, collapsibleHeight } = useCollapsible({ initialOpen })

  return (
    <section className="collapsible-section">
      <div className="collapsible-section__row">
        {title}
        <div className="collapsible-section__divider" />
        <IconButton
          iconProps={{
            icon: 'angledown',
            type: ICON_TYPES.OUTLINE,
            width: '24px',
            height: '24px',
          }}
          onClick={() => setOpen((open) => !open)}
          classes={{
            icon: classNames('collapsible-section__icon-collapsible', {
              'collapsible-section__icon-collapsible--open': open,
            }),
            button: 'collapsible-section__button-collapsible',
          }}
        />
      </div>
      <div className="collapsible-section__description">{description}</div>
      <div
        ref={getCollapsibleRef}
        style={{ height: collapsibleHeight || 'auto' }}
        className={classNames('collapsible-section__row', {
          'collapsible-section__row--closed': !open,
        })}
      >
        {children}
      </div>
    </section>
  )
}

export default CollapsibleSection
